import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { TOFU_WORKSPACE_UNLOCK_ALL } from "./gql";

const useUnlockAllTofuWorkspaces = createDefaultMutationHook(TOFU_WORKSPACE_UNLOCK_ALL);

export default useUnlockAllTofuWorkspaces;
